import { Dialog } from "cerulean";
import { useLocalization } from "@fluent/react";
import AppDownloadMobile from "../dashboard/AppDownloadDialogBody/AppDownloadMobile";

interface AppDownloadDialogProps {
  isOpen: boolean;
  fiName: string;
  androidUrl: string;
  appleUrl: string;
  closeDialog: () => void;
}

const AppDownloadDialog = ({
  fiName,
  androidUrl,
  appleUrl,
}: AppDownloadDialogProps) => {
  const { l10n } = useLocalization();
  return (
  <Dialog
    isOpen={true}
    title={l10n.getString("title-download-mobile-app", null, "Download the mobile app")}
    onUserDismiss={() => window.location.assign("/")}
  >
    <div className="margin--top--s" />
    <AppDownloadMobile
      fiName={fiName}
      androidUrl={androidUrl}
      appleUrl={appleUrl}
    />
  </Dialog>
);
};

export default AppDownloadDialog;
